import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import BackArrow from '@xsite-ui/prequal-funnels.assets/back-arrow';
import React, { useState, useEffect } from 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import { minDesktopWidth, grey, mainGreen } from '@xsite-ui/prequal-funnels.constants';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: ", "px ", "px;\n  ", ";\n  gap: 14px;\n\n  @media (min-width: ", ") {\n    max-width: 360px;\n    margin: 28px auto 0;\n  }\n"])), function (_ref) {
  var _theme$space;

  var theme = _ref.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$space = theme.space) === null || _theme$space === void 0 ? void 0 : _theme$space[6]) || 24;
}, function (_ref2) {
  var _theme$space2;

  var theme = _ref2.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$space2 = theme.space) === null || _theme$space2 === void 0 ? void 0 : _theme$space2[5]) || 16;
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isHomeInsurance) && "width: 100%; max-width: 500px; padding-top: 16px;";
}, minDesktopWidth);
var BackButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n"])));
styled.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 20px;\n  width: 10px;\n"])));
var EmptyProgressBar = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 9px;\n  background-color: ", ";\n  border-radius: 11px;\n"])), grey);
var FilledProgressBar = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 100%;\n  transition: width 0.4s 0.3s;\n  border-top-left-radius: 11px;\n  border-bottom-left-radius: 11px;\n  width: ", "%;\n"])), function (_ref3) {
  var _theme$colors;

  var theme = _ref3.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.purple[2]) || mainGreen;
}, function (props) {
  return props.percentage;
});

var ProgressBar = function ProgressBar(_ref) {
  var _includes;

  var initPrevStep = _ref.initPrevStep,
      _ref$funnelName = _ref.funnelName,
      funnelName = _ref$funnelName === void 0 ? '' : _ref$funnelName,
      totalProgress = _ref.totalProgress;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      percentage = _useState2[0],
      setPercentage = _useState2[1];

  var isHomeInsuranceOrPersonal = (_includes = ['home_leadgen', 'personal_loans_shopping', 'debt_consolidation_loans'].includes(funnelName)) !== null && _includes !== void 0 ? _includes : false;
  useEffect(function () {
    setPercentage(totalProgress);
  }, [totalProgress]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "progress-bar-wrapper",
    isHomeInsurance: isHomeInsuranceOrPersonal
  }, isHomeInsuranceOrPersonal && /*#__PURE__*/React.createElement(BackButton, {
    type: "button",
    onClick: initPrevStep
  }, /*#__PURE__*/React.createElement(BackArrow, null)), /*#__PURE__*/React.createElement(EmptyProgressBar, null, /*#__PURE__*/React.createElement(FilledProgressBar, {
    "data-testid": "filled-progress-bar",
    percentage: percentage
  })));
};

export { ProgressBar };
